<template>
  <v-dialog
    v-model="dialog"
    width="500"
    height="500"
    @keydown.13="okPushed"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="icon"
        class="deleteBtn"
        :color="color"
        :disabled="isButtonDisabled"
        :icon="iconOnly"
        :x-large="iconXl"
        :x-small="iconXs"
        :loading="loading"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>
          {{ iconMdi }}
        </v-icon>
        <template
          v-if="!noText"
          class="ml-2"
        >
          {{ btnText }}
        </template>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="mb-0">
        {{ $t("notification.information") }}
      </v-card-title>
      <v-card-text
        class="pb-4 pl-4 mt-n4"
        style="white-space: pre-line"
      >
        {{ text }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="okPushed"
        >
          {{ $t("dialog.ok") }}
        </v-btn>
        <v-btn
          v-if="cancelShow"
          text
          @click="cancelPushed"
        >
          {{ $t("dialog.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    cancelShow: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "error",
    },
    icon: {
      type: Boolean,
      default: true,
    },
    iconMdi: {
      type: String,
      default: "mdi-delete",
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    iconXl: {
      type: Boolean,
      default: false,
    },
    iconXs: {
      type: Boolean,
      default: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
    noText: {
      type: Boolean,
      default: false,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnText: this.$t("profile.sections.common.delete"),
      dialog: false,
    };
  },
  watch: {
    openDialog: function (val) {
      this.dialog = val;
    },
  },
  methods: {
    okPushed() {
      this.$emit("ok-pushed");
      this.dialog = false;
    },
    cancelPushed() {
      this.$emit("cancel-pushed");
      this.dialog = false;
    },
  },
};
</script>

<style></style>
